module.exports = __webpack_public_path__ + "img/logo.82b9163b.png";